import { HttpErrorResponse } from '@angular/common/http';

export function getError(errorResponse: HttpErrorResponse) {
  let message = '';
  const errorObject = errorResponse.error;

  if (errorObject) {
    if (typeof errorObject.error === 'string') {
      message = errorObject.error;
    } else if (Array.isArray(errorObject.errors)) {
      message = errorObject.errors[0];
    }
  }

  return message || 'An unknown error occurred';
}

export function getErrorCodeFromServerErrors(errorResponse: HttpErrorResponse) {
  let errorCode = '';
  const errorObject = errorResponse.error;

  if (errorObject?.errors && Array.isArray(errorObject.errors)) {
    errorCode = errorObject.errors[0].code;
  }

  return errorCode || 'UNKNOWN_ERROR';
}
